import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: translations.en,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem("maly_lang");
    if (stored === "en" || stored === "de") return stored;
    const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
    return browser === "de" ? "de" : "en";
  });

  const setLang = (l) => {
    setLangState(l);
    try { window.localStorage.setItem("maly_lang", l); } catch (e) { void e; }
  };

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: translations[lang],
  };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
